<template>
  <div class="">
    <!-- <div>Names Array: {{ commentData.indexNo }}</div> -->
    <div class="pa-4" style="background-color: #ecf1f2">
      <div class="d-flex justify-space-between align-center">
        <h1>
          Comments <span class="ml-2">({{ totalForums }})</span>
        </h1>
        <div class="d-flex">
          <v-icon
            style="color: rgba(8, 8, 22, 0.6)"
            @click="cancel"
            class="ml-8"
            >mdi-close</v-icon
          >
        </div>
      </div>
      <div class="d-flex my-1">
        <v-card style="width: 5.5rem" flat color="transparent">
          <v-img :src="commentarray.SubmittedByProfileImage"></v-img>
        </v-card>
        <span class="ml-7"
          ><b>{{ commentarray.Title }}</b></span
        >
      </div>
    </div>
    <div class="pa-5 pt-0">
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" md="8" sm="6">
            <v-card flat>
              <v-text-field
                flat
                dense
                background-color="#ECF1F2"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                v-model="search"
                hide-details
                single-line
                solo
              >
              </v-text-field>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div
        v-for="(comment, index) in filteredComments"
        :key="index"
        class="my-5"
      >
        <div>
          <div class="d-flex">
            <v-card flat color="transparent" class="mt-1">
              <img
                style="height: 45px; width: 45px; object-fit: cover;object-position: center; background-color: white;"
                :src="
                  comment.SubmittedByProfileImage ||
                  'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
                "
                @error="setDefaultImage"
              />
            </v-card>
            <div class="ml-3" style="width: 100%">
              <div class="d-flex justify-space-between">
                <div>
                  <div>
                    <b> {{ comment.SubmittedByName }}</b>
                  </div>
                  <div>
                    <span class="date_style">{{
                      comment.CreatedDate.split("T")[0]
                    }}</span>
                  </div>
                </div>

                <div>
                  <span
                    v-if="!comment.isViewed"
                    style="color: #bc7410"
                    class="cursor-pointer"
                    >New comment</span
                  >
                  <v-icon
                    color="red"
                    class="mx-4 cursor-pointer"
                    @click="openConfirmDialog(comment.Id)"
                    >mdi-delete-forever</v-icon
                  >
                  <v-btn icon @click="toggleIsPlaying(comment)">
                    <v-icon
                      v-if="comment.Visibility"
                      color="primary"
                      class="cursor-pointer"
                      >mdi-eye</v-icon
                    >
                    <v-icon v-else>mdi-eye-off</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="my-4">
            <span
              style="color: #363636; font-size: 13px"
              v-html="comment.Comment"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
    <!----------Archived screen--------->
    <v-dialog v-model="ArchivedDialog" max-width="290">
      <v-card class="pa-14"><EmptyBoxSvg></EmptyBoxSvg></v-card>
    </v-dialog>
    <!--------Archived screen----------->
    <v-dialog v-model="deletedailog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deletedailog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="btnloader" @click="deleteComment()">
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EmptyBoxSvg from "../../assets/SvgIcons/Emptyboxsvg.vue";
import { mapGetters } from "vuex";
export default {
  components: { EmptyBoxSvg },
  name: "Comment",
  props: ["commentarray", "totalForums"],
  data() {
    return {
      btnloader: false,
      search: "",
      deleteCommentId: null,
      itemsPerPage: 5,
      deletedailog: false,
      ArchivedDialog: false,
      filterItem: [
        {
          text: "By Status (Active, inactive, New comment)",
        },
        {
          text: "By Date ",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["GetForumComments"]),
    filteredComments() {
      const searchQuery = this.search.toLowerCase();
      return this.GetForumComments.filter(
        (Comment) =>
          Comment.Comment.toLowerCase().includes(searchQuery) ||
          Comment.SubmittedByName.toLowerCase().includes(searchQuery)
      );
    },
  },
 
  methods: {
    setDefaultImage(event) {
      event.target.src = 'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
    },
    openConfirmDialog(id) {
      this.deleteCommentId = id;
      this.deletedailog = true;
    },
    deleteComment() {
      this.btnloader=true;
      this.$store
        .dispatch("DeleteForumComment", this.deleteCommentId)
        .then(() => {
          this.btnloader=false;
          this.deletedailog = false;
          this.$swal.fire({
          toast: true,
          icon: "success",
          title: "Comment Deleted Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
          this.$emit("callApi");
        });
    },
    toggleIsPlaying(item) {
      const Id = item.Id;
      this.$store.dispatch("ToggleVisiblityComment", Id).then(() => {
        this.$emit("callApi");
      });
    },
    cancel() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: " DM Sans";
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
}
.date_style {
  font-family: "DM Sans";
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
}
</style>
